export default "__VITE_ASSET__CAO_6o8H__"